import React, { createContext, useContext, useState, useEffect } from 'react';

const NotificationSettingsContext = createContext();

export const useNotificationSettings = () => {
  const context = useContext(NotificationSettingsContext);
  if (!context) {
    throw new Error('useNotificationSettings must be used within a NotificationSettingsProvider');
  }
  return context;
};

export const NotificationSettingsProvider = ({ children }) => {
  // Default settings
  const [settings, setSettings] = useState({
    enabled: false, // DISABLED: Polling notifikasi dimatikan secara default
    interval: 300, // seconds (5 minutes)
    sound: true,
    desktop: false,
    autoMarkRead: false
  });

  // Load settings from localStorage on mount
  useEffect(() => {
    const savedSettings = localStorage.getItem('notificationSettings');
    if (savedSettings) {
      try {
        const parsed = JSON.parse(savedSettings);
        setSettings(prev => ({ ...prev, ...parsed }));
      } catch (error) {
        console.error('Error parsing notification settings:', error);
      }
    }
  }, []);

  // Save settings to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem('notificationSettings', JSON.stringify(settings));
  }, [settings]);

  const updateSettings = (newSettings) => {
    setSettings(prev => ({ ...prev, ...newSettings }));
  };

  const resetSettings = () => {
    setSettings({
      enabled: false, // DISABLED: Polling notifikasi dimatikan secara default
      interval: 300, // 5 minutes
      sound: true,
      desktop: false,
      autoMarkRead: false
    });
  };

  const value = {
    settings,
    updateSettings,
    resetSettings,
    // Helper functions
    isEnabled: settings.enabled,
    intervalMs: settings.interval * 1000,
    intervalOptions: [
      { value: 10, label: '10 detik' },
      { value: 30, label: '30 detik' },
      { value: 60, label: '1 menit' },
      { value: 120, label: '2 menit' },
      { value: 300, label: '5 menit' },
      { value: 600, label: '10 menit' }
    ]
  };

  return (
    <NotificationSettingsContext.Provider value={value}>
      {children}
    </NotificationSettingsContext.Provider>
  );
};